import $http from "../../global/http";
import PrestoSdk from "../../global/PrestoSdk";
import $ from "../../global/util";

const OffersResource = function ($http, PrestoSdk) {
  function getHomePageOffers() {
    var url =
      PrestoSdk.getHostName() +
      "/apps/" +
      PrestoSdk.getAppId() +
      "/home_page_offer.json";
    return $http.get(url);
  }
  function getItemPromotions(params) {
    let url =
      PrestoSdk.getHostName() +
      "/employee/v1/item_promotions/for_item_reference_ids.json";
    return $http.post(url, params);
  }
  return {
    getHomePageOffers: getHomePageOffers,
    getItemPromotions: getItemPromotions,
  };
};

export default OffersResource($http, PrestoSdk);
